import React from 'react';
import { createHashRouter, Navigate, RouterProvider } from 'react-router-dom';
import { MainLayout } from '../layouts';
import { Failed, Home, Kyc, NotFound, FAQ, PaymentFailed , PaymentSuccess, Stage } from '../../presentation';
import { DataProvider } from '../../adapter';
 
const router = createHashRouter([
    {
        index: true,
        element: <Navigate to="/home" replace />
    },
    {
        path: '/',
        element: <MainLayout />,
        children: [
            {
                index: true,
                element: <Navigate to="/home" replace />
            },
            {
                path: 'home',
                element: <Home />
            },
            {
                path: 'kyc',
                element: <Kyc />
            },
            {
                path: 'not-found',
                element: <Failed />
            },
            {
                path: '*',
                element: <NotFound />
            },
            {
                path: 'faq',
                element: <FAQ />
            },
            {
                path: 'failed',
                element: <PaymentFailed />
            },
            {
                path: 'success',
                element: <PaymentSuccess />
            }
        ]
    },
    {
        path: 'stage/:id',
        element: <Stage />
    }
]);
 
export default function MainRoutes() {
    return (
        <DataProvider>
            <RouterProvider router={router}>
            </RouterProvider>
        </DataProvider>
    );
}